<template>
  <svg width="6" height="26" viewBox="0 0 6 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="3" fill="#277FAF" />
    <circle cx="3" cy="13" r="3" fill="#277FAF" />
    <circle cx="3" cy="23" r="3" fill="#277FAF" />
  </svg>
</template>

<script>
export default {
  name: 'MenuMore',
}
</script>

<style scoped></style>
